export default __webpack_public_path__ + "static/media/c1.79a7428e.png";